var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-item-group',{staticClass:"xyz",attrs:{"item":_vm.item,"text":"","prepend-icon":_vm.item.icon,"sub-group":"","append-icon":"mdi-menu-down"}})}
var staticRenderFns = []

export { render, staticRenderFns }